import request from '@/utils/request'

// 获取供需类别标签列表
export function postMobileApi(){
    return request({
        url: '/web/gxlb/getGxTypeTag',
        method: 'post'
    })
}

// 发布供需
export function postSupplyDemand(data) {
    return request({
        url: '/web/gxlb/add',
        method: 'post',
        data: data
    })
}
